export default {
	type: 'object',
	properties: {
		obsToken: { type: 'string' },
	},
	required: [],
	additionalProperties: false,
}
